import TermsConditions from "components/TermsConditions";
import ForgotPassword from "./AuthPages/ForgotPassword";
import Login from "./AuthPages/Login/Index";
import ResetPassword from "./AuthPages/ResetPassword";
import SignUp from "./AuthPages/Signup";
import OtpVerification from "./AuthPages/Signup/component/OTPverification";
import Contact from "./SideTabPages/Contact";
import Home from "./SideTabPages/Home";
import ProfilePage from "./SideTabPages/ProfilePage";
import SubscriptionBuy from "./SideTabPages/Subscription";
import RejectPage from "./SideTabPages/Subscription/component/Response/Cancel";
import SuccessPage from "./SideTabPages/Subscription/component/Response/Success";
import Workbook from "./SideTabPages/WorkBook";

export const routes = [
  { path: "/login", component: <Login /> },
  { path: "/signup", component: <SignUp /> },
  { path: "/otp-verification", component: <OtpVerification /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/reset-password", component: <ResetPassword /> },
];

export const privateRoutes = [
  { path: "/home", component: <Home /> },
  { path: "/contact", component: <Contact /> },
  { path: "/my-profile", component: <ProfilePage /> },
  { path: "/subscription", component: <SubscriptionBuy /> },
  { path: "/workbook/:_id", component: <Workbook />, isExclusive: true },
  { path: "/success", component: <SuccessPage /> },
  { path: "/cancel", component: <RejectPage /> },
];